// extracted by mini-css-extract-plugin
export default {"container":"safety_container__f8ns6","blok":"safety_blok__RwWUq","h3":"safety_h3__2SPOn","li":"safety_li__2XYmb"};